export default __webpack_public_path__ + "static/media/hht2_ep11_speaking_02.0963bd54.png";